<template>
    <div class="reo-tip" @mouseleave="debounceHandleShow(false)" @mouseenter="debounceHandleShow(true)">
        <slot name="icon" v-if="customIcon"></slot>
        <i v-else class="tip-icon icon-co_tips_line" @click="debounceHandleShow(true)"/>
        <popper ref="popper"
            v-model="show"
            placement='top-start'
            :offset="!isMobile?20:0"
            :visibleArrow='!isMobile'>
        </popper>
        <div ref="fly-piece"
            v-show="show"
            class="my-picker__popper"
            @mouseleave="debounceHandleShow(false)"
            @mouseenter="debounceHandleShow(true)"
            @touchstart.stop
        >
            <div class="content" :style="style">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Popper from 'element-ui/lib/utils/vue-popper.js';
import { Optimization } from '@reolink-web/utils';
import { NOOP } from '@/utils';

Popper.render = ( h ) => h( null );

const { debounce } = Optimization;

export default Vue.extend({
    props: {
        width: {
            type: [String, Number],
            default: 'auto'
        },
        customIcon: {
            type: Boolean,
            default: false
        }
    },

    components: {
        Popper
    },

    mounted (): void {

        document.getElementsByTagName( 'body' )[0].addEventListener( 'touchstart', this.touchstart );
        ( this.$refs.popper as any ).popperElm = this.$refs['fly-piece'];
        ( this.$refs.popper as any ).referenceElm = this.$el;

    },

    destroyed (): void {

        document.getElementsByTagName( 'body' )[0].removeEventListener( 'touchstart', this.touchstart );

    },

    data () {

        return {

            show: false,
            debounceHandleShow: NOOP as (( isShow: boolean ) => void )

        };

    },

    created() {

        this.debounceHandleShow = debounce( this.handleShow, 200 );

    },

    methods: {

        touchstart ( e ): void {

            let outSide = !Array.from( e.target.classList ).includes( 'reo-tip' ) && !e.target.closest( '.reo-tip' );
            if ( outSide && this.show ) {

                this.show = false;

            }

        },

        handleShow( isShow: boolean ) {

            this.show = isShow;

        }

    },
    computed: {

        isMobile(): boolean {

            return this.$store.getters.isMobile;

        },
        style (): Record<string, string> {

            let promptWidth;
            if ( this.width ) {

                promptWidth = this.width;

            } else {

                promptWidth = this.isMobile ? '6.9rem' : '3.2rem';

            }
            return {
                '--prompt-width': promptWidth
            };

        }
    }

});
</script>

<style scoped lang="less">
.reo-tip{
    position: relative;
    display: inline-flex;
    vertical-align: bottom;
    z-index: 2;
    font-size: 0;
}
.tip-icon{
    font-size: 17px;
    cursor: pointer;
    color: @black;
}
.content{
    padding: 16px;
    box-sizing: border-box;
    background: @black8;
    max-width: 288px;
    font-size: 14px;
    /* display: none; */
    text-align: left;
    color: @font_primary_dark;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    border: 1px solid rgba(#FFFFFF, 0.07);
    border-radius: 4px;
    box-shadow: 0px 2px 10px 0px rgba(#000000, 0.23);
}
.content /deep/ a{
    color: @white;
    text-decoration: underline;
    &:hover{
        color: @b_5;
        .text{
            border: none;
        }
    }
}
.content p{
    margin: 0;
}
/* .reo-tip:hover .content{
    display: block !important;
} */
.content a .ui-icon{
    transform: scale(0.5) translateY(36%);
    display: inline-block;
}
@media @mobile {
    div.content p{
        font-size: 12px;
    }
}
</style>
